import Reveal from "@/components/base/Reveal";

const POINTS = [
  {
    title: "先看时间线，再看观点",
    desc: "同一件事在不同时间被讨论的角度会变。把时间线拉直，很多看似矛盾的说法其实并不冲突。",
  },
  {
    title: "分清事实、转述和情绪",
    desc: "我们会在整理时标注信息来源，把可核实的事实和网友的情绪表达分开呈现，减少误读。",
  },
  {
    title: "留意讨论的拐点",
    desc: "热度曲线上的每一个陡增都对应一个关键节点，找到那个节点，往往就找到了争议的源头。",
  },
  {
    title: "给结论留一点余地",
    desc: "尚未有明确结论的话题，我们会保留争议点不做单方面判断，也欢迎你补充新的线索。",
  },
];

export default function DeepDiveSection() {
  return (
    <section id="dive" className="scroll-mt-20 bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <div className="relative h-72 w-full overflow-hidden rounded-lg md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20desk%20scene%20with%20warm%20amber%20desk%20lamp%2C%20stacked%20cream%20paper%20notes%20and%20a%20vintage%20timeline%20chart%2C%20cozy%20study%20atmosphere%2C%20soft%20golden%20light%2C%20cinematic%20still%20life%2C%20warm%20neutral%20palette&width=1000&height=760&seq=gossip-dive-main&orientation=landscape"
              alt="深度围观的话题梳理工作场景"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 rounded-md bg-foreground-950/70 px-4 py-3 backdrop-blur-sm">
              <p className="font-heading text-lg font-bold text-background-50">深度围观</p>
              <p className="mt-0.5 text-xs text-background-200">从一个热搜，看懂一场讨论</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.28em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            Deep Dive
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            一场讨论是怎么从热搜走到共识的
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            热度只是入口，不是答案。我们把每一次围观拆成可复用的四个步骤，帮你从「看到热搜」走到「看懂来龙去脉」。
          </p>

          <ol className="mt-8 space-y-5">
            {POINTS.map((point, index) => (
              <li key={point.title} className="flex gap-4">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 font-heading text-sm font-bold text-foreground-950">
                  {index + 1}
                </span>
                <div>
                  <h3 className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                    {point.title}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {point.desc}
                  </p>
                </div>
              </li>
            ))}
          </ol>

          <a
            href="#topics"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            挑一个话题试试
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}